"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvFromQueryParam = exports.getEnvFromTLD = void 0;
const env_1 = require("./env");
/**
 * Returns the Env from the top level domain if possible
 * @param location
 * @returns Env or null
 */
function getEnvFromTLD(location) {
    const { host } = location;
    if (host.endsWith('.org') || host.endsWith('.co')) {
        return env_1.Env.PRODUCTION;
    }
    else if (host.endsWith('.today') || host.endsWith('.net')) {
        return env_1.Env.STAGING;
    }
    else if (host.endsWith('.io') || host.endsWith('.zone')) {
        return env_1.Env.DEVELOPMENT;
    }
    return null;
}
exports.getEnvFromTLD = getEnvFromTLD;
/**
 * Returns the Env from the query param if possible
 * @param location
 * @returns Env or null
 */
function getEnvFromQueryParam(location) {
    const search = new URLSearchParams(location.search);
    const param = search.get('ENV') || search.get('env');
    if (param) {
        const env = param.toLowerCase();
        if ((0, env_1.isEnv)(env)) {
            return env;
        }
    }
    return null;
}
exports.getEnvFromQueryParam = getEnvFromQueryParam;
//# sourceMappingURL=location.js.map